export const talents = [
    "成就", "行动", "适应", "分析", "统筹", "理念", "信仰", "统率", "沟通", "竞争",
    "关联", "公平", "回顾", "审慎", "伯乐", "纪律", "体谅", "专注", "前瞻", "和谐", "包容", "个别",
    "搜集", "思维", "学习", "完美", "积极", "责任", "排难", "交往", "自信", "追求",
    "战略", "取悦"
];

export const talentQuestions = {
    "成就": [
        "我闲不下来",
        "如果我早上写下了今天要完成的三件事，晚上还没有完成，我会感到惭愧",
        "跟朋友一起休闲的时候，我会觉得自己在浪费时间",
        "我想干一些看得见成果的事，而不是做一些狗屁工作",
        "我小时候就有远大理想，我很怀疑所谓平平淡淡就是碌碌无为",
        "我觉得有很多事情可以去做，我总是看得见可以改善的地方，我总觉得时间不够用",
        "我看到别人在忙的时候，也想加入",
        "我休假的时候脑子里也一直想着工作",
        "我不需要休息，让我干自己喜欢的事就是休息",
        "我总觉得别人很低效，我一天能干完的事别人三天还没干完"
    ],
    "行动": [
        "我很烦那些只说不干的人",
        "只要我喜欢自己的某个想法，启动起来很容易",
        "当别人的计划打动了我，我就会问什么时候去干",
        "我曾经做过一些在别人看来冒险的事，原因就是当下心血来潮",
        "我有时发表观点会有些冲动，甚至不太得体",
        "我认为不需要想太多，开始去干，后面随机应变就好",
        "我总能想象出一些激动人心的图景，从而想要立马行动",
        "我总觉得别人设想了太多障碍，本来就没有一切顺利的事，做了才有机会",
        "我认为人们对那些失败的改革派太苛责了，不去试怎么知道不会成功？",
        "我经常根据实际情况改变行动方向，就算暂停了某个项目，也会马上开启下一个项目"
    ],
    "适应": [
        "我很好说话",
        "大部分时候我很愿意配合别人的工作",
        "我觉得我能理解别人的需要，即便这个人跟我立场不一致",
        "如果上司宣布了一个意外的消息，我也马上能接受，马上调整工作",
        "我不太能理解那些目标明确的人，因为我认为任何目标都是死板僵化的",
        "别人认为我很镇定，原因是我觉得任何意外都在意料之中",
        "我总觉得有些人为人处世不太圆融",
        "出门旅游，如果我实在累了，可能走到一半都会放弃原来的目的地，打道回府",
        "很多事情我也搞不懂为什么，但我也可以继续跟它们周旋",
        "我反感人们使用'不确定性'这个词，我觉得这是一个完全多余概念，没有什么是确定的"
    ],
    "分析": [
        "我认为直觉的可信度往往被夸大了",
        "我相信数据，至少它比很多东西真实",
        "我常常觉得别人得出一些错误的结论，原因是他们思考不够严谨",
        "如果别人说了一个结论或观点，我就忍不住问为什么",
        "我习惯性地去探究现象背后的根源和规律",
        "我喜欢有条理、结构化的表达",
        "我思考问题尽量穷尽所有情况，这样我才会感到踏实",
        "我鄙视那些对数据不敏感的人",
        "我需要一些客观的东西来帮我做决策",
        "有很多人不能说服我，而且我觉得他们很容易被一些言论煽动和欺骗"
    ],
    "统筹": [
        "我可以同时处理很多事",
        "我发现别人不像我一样，能够快速切换注意力",
        "我眼观六路耳听八方",
        "越混乱的局面，越是我发挥的地方，我可以把一切安排得井井有条",
        "我喜欢去做协调人员的工作，我认为人就是资源，我能通过协调人让资源组合起来",
        "我的时间表经常很满，但我以此为豪，不以之为压力",
        "我经常忙里插针",
        "我擅长部门之间的沟通与协作，因为我能平衡各方意见和利益",
        "我希望我在安排事情的时候，别人能听从我的指挥",
        "我总是有办法"
    ],
    "理念": [
        "我喜欢原创、欣赏原创，模仿在我看来就很掉价",
        "我对文艺作品涉猎很广，什么都看，我觉得它们各有各的意思，我从中获得灵感和乐趣",
        "我喜欢脱口秀或者喜剧作品，我欣赏幽默，我认为幽默提供给了人们看待生活的有趣视角",
        "我有时会主动发起一些小变化或小恶作剧，这样能让生活增添趣味，也能让我精神抖擞",
        "如果能够遇到跟我一样脑洞大开的人，我们就会畅谈甚欢",
        "如果我去参加一个头脑风暴的会，我基本上可以断定自己是话最多的那个",
        "我需要阅读，并不是因为我热爱学习，而是阅读能带给我灵感",
        "虽然我的想法不成熟，甚至听起来不靠谱，但至少它们很有趣。我认为有趣才是最重要的",
        "我总是有解决问题的点子，至于它是否行得通，别人采不采用，那是另一回事了",
        "我认为怪诞和深刻不仅不矛盾，还经常连在一起"
    ],
    "信仰": [
        "我拥有不变的价值观，这些价值观驱动我完成很多工作",
        "金钱和名望对我来说不太重要",
        "相比自己，我发现别人总是很容易受到一些引诱和干扰",
        "在有的人眼里，我像是一个圣人，但我知道遵循自己的内心，才能让我活得更自在和坦然",
        "我为人处世有原则，且经得起考验",
        "我的生活是有意义的，也是有方向的",
        "我从事过不少志愿工作，因为它们符合我的价值观",
        "我通过价值观识别同伴和路人",
        "我工作中的很多灵感，来自我的价值观",
        "我相信对的事情，只要一直做下去，就会产生影响"
    ],
    "统率": [
        "我觉得别人都犹豫不定、不敢做决定",
        "我可以并且喜欢发号施令",
        "让别人知道我的脾气，是有必要的",
        "有时候我很生气，但有的时候只是装作生气",
        "开诚布公是团队最高效的沟通方式，我愿意做表率",
        "立场鲜明是最好的，这样才有号召力",
        "有的人该踢出局就踢出局",
        "别人有时会怕我的咄咄逼人，而不敢跟我说话",
        "我知道自己一说话，至少气势上会显得很有理",
        "挑衅对我来说不是难事"
    ],
    "沟通": [
        "我愿意用简单生动的语言，向别人解释复杂晦涩的知识",
        "我享受接梗把人逗笑",
        "我同意'未经描述的，就是不存在的'",
        "我懂得怎么表达能够吸引别人注意力",
        "我觉得自己比大多数人更精于言辞",
        "我喜欢去寻找合适的词语，一旦找到我就特别高兴",
        "我表达欲有的时候蓬勃",
        "我认为自己是一个很透明的人，因为有什么想法我都说出来（或者写出来）",
        "我喜欢用写作来表达自己的思想，我认为表达是一种重要的行动",
        "跟刚认识的人把天聊下去，对我来说没有压力，并非我活泼外向，而是我总能从一个话题展开，像个话篓子"
    ],
    "竞争": [
        "我喜欢把自己跟别人比较",
        "如果没有对手，我就没有动力",
        "在竞争中取胜，是我最开心的事",
        "我经常跟自己以前比，找到可衡量的进步",
        "我喜欢把工作中的一些事情游戏化和竞争化",
        "我喜欢带着大家一起打仗的感觉",
        "我喜欢做结果可量化衡量的工作，这样我能清晰看到自己和别人的差距",
        "真正上场的时候，我的状态会比训练时更好",
        "我需要一个可以去超越的目标",
        "我只做胜出的可能性大的事，我不相信什么重在参与"
    ],
    "关联": [
        "我相信善有善报恶有恶报",
        "我总觉得这个世界的很多悲剧，人人都有责任",
        "我做事考虑后果，甚至是非常遥远的后果",
        "我能跟不同文化背景的人进行很好的交流，我擅长寻找那些共通的话题，激发共同的情感",
        "我擅长在看似很远的事物之间，找到合理的关联",
        "我心怀众生",
        "我有时觉得身边的人太自我为中心，因为他们不知道自己鲁莽的言行会给看不见的人带来什么影响",
        "我不容易出现意义感缺失，我总能从自己做的事情中找到意义",
        "我不排斥那些无法解释的、神秘的事情",
        "我认为天行有道，个人是无力的，但又能对世界产生蝴蝶效应那样的影响"
    ],
    "公平": [
        "我永远不会公开表达自己对下属或晚辈的偏爱，甚至我认为自己没有偏爱",
        "一个健康的组织，需要公平透明的规则",
        "我讨厌以社会地位去划分人",
        "每个人的能力不一样，但还是要给大家公平的机会",
        "别人信赖我，是因为我处事公平",
        "我从来不为自己争取特殊对待，甚至以此为耻",
        "如果有人对我抱怨另一个人，我经常怀疑对方的指责是否公平",
        "我不去破坏规则，并且认为别人也不应该破坏，因为一旦破坏就没有人在意它了",
        "我比别人更痛恨腐败、行贿等行为",
        "我认为坚持公平就算会损失短期的效率，但长期来说会带来效率"
    ],
    "回顾": [
        "如果无法从过去总结规律，我会感到迷茫",
        "如果别人找我咨询问题，我喜欢仔细了解他们过去是怎么做的",
        "我认为回顾过去就能产生智慧",
        "我认为人们可以从古老的东西中获得某种力量",
        "我喜欢跟年纪大的人交谈，听他们讲过去的事情",
        "加入一家新公司，我会去了解它的历史",
        "我认为在前进之前，最好先回顾过去，这能让我们走得更稳",
        "当我充分了解了一个事物的过去，我就能找出很多问题的答案",
        "我认为未来也是过去的重复，我喜欢通过过去预测未来",
        "我对过去的事情刨根问题，因为这是我建立自己认知地图的方式"
    ],
    "审慎": [
        "我并不是不行动，而是三思而后行",
        "我会想象各种意外情况，非常小的小概率事件，我脑海中也会想象它发生的情景",
        "我很少欣喜若狂，就算中了彩票我也马上会去想接下来会出现什么问题",
        "我需要花比别人更长的时间做出决定，因为我要仔细权衡利弊",
        "我擅长处理需要细心的工作",
        "我认为自己工作能力比很多人强，因为那些人头脑简单，经常一猛子扎进去，最后没法收场",
        "很多时候我不想泼冷水，我只好保留自己的看法",
        "大体来说我是一个保守的人，并不是我思想不开明，而是我讲求实际",
        "我不喜欢从事高风险的投资，我无法享受大起大落的冲击",
        "我的谨慎让我少了很多麻烦，我会觉得别人把事情考虑得太简单了，从而让自己麻烦缠身"
    ],
    "伯乐": [
        "我可以看到每个人身上的优点，比起缺点，我更关注他们的优点",
        "我可以坦诚地表达欣赏和鼓励",
        "看到别人的进步我很开心",
        "我给下属布置艰难的任务，不是为了难为他们，而是为了帮助他们成长",
        "我偶尔严厉，大部分时候是温和的，因为有的严厉是为了对方好",
        "我对人有耐心，因为变化需要时间",
        "我容易关注到别人由内而外的变化，可能是因为我从心底里关心他们的成长",
        "我不会把人当工具",
        "收到别人的感谢信，感谢我曾经的某个举动对他产生的深刻影响，这是我人生中最高兴的时候了",
        "看到别人自暴自弃，我就忍不住去想拉他一把"
    ],
    "纪律": [
        "比起别人，我更容易适应军队的生活方式，甚至我喜欢这种生活",
        "只要制定了时间表，我就可以按计划行动",
        "我觉得很多人事情做不成，是因为他们太容易放任自流",
        "我喜欢检查，不管是检查物品是否在该在的地方，还是检查人员是否准备就绪",
        "我喜欢去使用时间管理的方法和工具，比如定时闹钟",
        "如果我是领导，我会很讨厌那些不遵守规则的员工",
        "我有的时候像一个工具箱，能给陷入麻烦的人提供及时的帮助，因为对那些可以意料的意外我都有准备",
        "我并不喜欢惊喜，对我来说它们可能是惊吓",
        "我喜欢别人告诉我准确的、而不是模糊的信息",
        "人们觉得我行动力强，我觉得有的人就是懒"
    ],
    "体谅": [
        "换位思考，对我来说是非常自然的事",
        "对方还没有流露情绪的时候，我好像就能感受对方的情绪",
        "如果在场的其他人不开心，我也会为此而不开心",
        "我经常倾听朋友们的长篇诉说，并能够让他们感到自己被理解",
        "有的人即便沉默，我也仿佛听到了他的观点",
        "我愿意通过语言上的安慰，让别人感到舒服",
        "我能听出别人的委婉表达的背后的意思",
        "我能读懂一个有深意的笑容",
        "我有时觉得一些人太迟钝，一定要别人说出来才明白",
        "我擅长文本细读，我能通过字里行间了解一个人的内心"
    ],
    "专注": [
        "职场中，必须确立目标，我会跟我的领导讨论清楚目标，然后才开始工作",
        "明确优先级对我来说非常重要，否则就会迷失",
        "如果一项任务跟我的团队的OKR无关，我能应付就应付",
        "我自己会不断校准目标，我也喜欢帮助大家校准目标",
        "下属跟我汇报工作的时候，我希望他直接说结论和重点，任何跟主题无关的信息都是多余信息",
        "我喜欢讲完一件事再讲另一件事，跳跃或者被打断会让我不舒服",
        "如果我持续投入准备某项工作，我的表现会很好，但如果这段时间内不能专心致志，我就会表现差很多",
        "我是一个强准备选手，不擅长随机应变临场发挥",
        "我有一股韧劲，可能是因为在我眼里目标最大",
        "没有目标或者目标不清晰，我会很难受"
    ],
    "前瞻": [
        "对未来的想象能让我激动",
        "我希望大家看到未来的前景而不是抱怨当下。如果当下有很多问题，正好说明改善空间大",
        "我的合作伙伴不如我有长远的眼光和判断",
        "如果我认为我的团队走在了一个错误的方向，而我又不能说服其他人，我可能迟早会离开",
        "同事或领导认为我'走得太快'，太超前",
        "GPT出现后，我就马上开始重新谋划业务甚至自己的职业生涯",
        "团队中我经常是向大家分享行业新动向的那个人",
        "我认为很多人因为看不到更远的未来，而把时间精力花在不值的地方",
        "尽管经济下行，我还是保持乐观，并寻找发展机会",
        "我愿意去做价值投资"
    ],
    "和谐": [
        "别人就观点进行争论的时候，我总觉得他们说的并不矛盾",
        "总体来说，我是一个务实的人，我觉得观点之争没有价值，只会破坏关系",
        "我能够跟不同立场的人建立关系，即便他们彼此之间水火不容",
        "什么样的观点我都能吸收和接纳，它们多少都能让我学到一些东西",
        "如果有可能的话，我认为自己会愿意从事外交官之类的工作，因为我能尊重立场不一致的人的看法",
        "如果让我负责一个谈判，我不会选择强压的策略，我认为和和气气地去谈，更可能拿到好结果",
        "我想不通为什么有的人要吵架呢？有什么话不能好好说呢？",
        "就算一件事跟我没有关系，我还是愿意插手，因为我希望看到双方达成共识",
        "我可能在团队里显得有些沉默，并不是我对大家有什么意见，我其实内心觉得大家都很好",
        "我很少在别人之前提出自己的主张或见解，我想先了解别人的想法，这样比较稳妥，不会冒犯到谁"
    ],
    "包容": [
        "小时候，我经常注意到班级里那些不太受欢迎的、甚至被排挤的同学，我认为事情不应当如此",
        "聚会上如果有人比较紧张和害羞，我会尽量让TA感到放松自然",
        "我不排斥跟背景迥异的人交往，并非因为我好奇，而是因为我心底里认为大家都是一样的人",
        "不管对方是什么样的人，我都能跟他沟通，甚至成为朋友，并非我社交技能高超，而是我坚信人心相通",
        "我认为很多人喜欢我的原因是，我让他们感到自己被接纳",
        "我不喜欢搞小帮派小团伙，我喜欢对大家一视同仁",
        "我的朋友圈子里什么样的人都有",
        "进入新环境，我可以比别人更快地认识更多的人，并非因为我是个社牛，而是我对谁都释放善意",
        "让每个人都觉得自己有价值会令我很有成就感",
        "我是大家眼中的好人，因为对某些被人评价不高的人，我会更宽容"
    ],
    "个别": [
        "我喜欢观察那些个性突出的人，并不是因为他们在人群中惹眼，而是我发自内心欣赏他们的独特",
        "我就像一个导演，可以让不同的人发挥自己所长，一起完成工作",
        "我不相信什么所谓的管理方法、什么流程优化，关键是选对人，把人放在合适的位置上",
        "如果我是领导，我会去发现每个成员的内在驱动力，然后点燃这个发动机，让他们高高兴兴干活",
        "我喜欢观察不同人的习惯和喜好，这有利于我理解对方的行为模式",
        "我经常会发现某个人跟我认识的另外某个人'很像'",
        "我观察有的管理者跟下属沟通的时候，经常不顾对方个性特点，只会噼里啪啦自我表达",
        "我相信世上并不只存在一种成功的方式",
        "我的社交风格比较灵活，因为我会看人下菜碟",
        "不同的人就像不同的动物，也就是说，人与人的差别，有时就像猫和狗之间的差别那么大"
    ],
    "搜集": [
        "我总是想知道更多，即便一件事跟我没有直接利害关系",
        "我打听一些事，不是当下要用到，而是为了以备不时之需。多知道一些总是有用的",
        "我相信：必须知道很多事情，才能真正了解某一件事",
        "别人可能觉得很奇怪，但我确实认为字典或者百科全书就是很好的读物",
        "即便我已经比别人知道更多，我还是觉得自己学识不足，我总想继续拓展它的广度或深度",
        "我经常收藏书籍、工具性网站这些东西，即便我其实很少用到它们",
        "我感觉我的阅读效果比一般人好，因为我会把新知识跟已有的知识联系起来",
        "食品包装上的营养成分表，我都能看得兴味盎然",
        "我关注我能接触到的各类信息，因此遇到某些状况的时候，我往往比别人有主意",
        "我有时觉得某些领域的专家也不过如此，我知道的都比他们多"
    ],
    "思维": [
        "我话不多，不是因为我内向，而是我更多的时间花在思考上，我更喜欢进行有深度有质量的输出",
        "我思考的主题远远超过了我的生活经验，但这完全不会阻止我继续",
        "我不是在睡觉，就是在思考。工作或者跟人交谈只是顺带的事",
        "我喜欢跟人讨论抽象问题，我享受这种大脑体操",
        "我很容易感受到他人言论的浅薄",
        "当别人发起一个话题，我会就此想到很多个就此延伸的话题",
        "我思考的时候，就像自己跟自己对话",
        "我很小的时候就喜欢阅读哲学思想",
        "我认为人的思考能力的确有高低之别，我能够很快分辨出那些脑子既快且清晰的人",
        "我常常觉得有的人太容易依靠本能做判断了。我并非感受不到我的本能，但我会自动地去质疑它"
    ],
    "学习": [
        "我发自内心认同'吾生也有涯，而学也无涯'",
        "对我来说，不断吸收新的东西，才能保持生命力",
        "比起在我熟悉的领域取得成绩，从零到一学会一个新东西，更能让我感到自信和骄傲",
        "比起成为专家，我更希望自己活成多面手",
        "不同类型的事情我都能搞定，或者快速上手，这让我很得意",
        "我学东西往往没有什么目的，我就是想学会",
        "我不喜欢给自己设限，只要条件允许，我认为自己能够干很多事",
        "学习新技能对我来说不是压力，是挑战",
        "我喜欢那种自我焕然一新的感觉",
        "上进就是我的价值观，人应该向更高更广的地方生长"
    ],
    "完美": [
        "当我形容一个人'优秀'的时候，我不是在羡慕TA的成就，而是在欣赏TA的才华",
        "看到优秀的人和作品，我的精神都会为之一振",
        "当我看到了朋友身上的某种才华，我会很想告诉TA,并希望TA无论如何不要放弃",
        "我对很多东西有自己的评价标准，外人可能无法理解，但我非常清楚它在哪里",
        "我很少发自内心去赞美别人，可能是我的标准太高",
        "如果一个人在某方面没有天赋，我内心会愿TA改行",
        "我打心底认为任何工作都可以精益求精，我不赞同很多人认为自己的工作无聊",
        "我常常会在一些细小的工作上投入大量时间，就是为了一再修改和优化",
        "我认为自己的感受力和观察能力比大部分人敏锐，这也意味着很多东西难以入我法眼",
        "我工作上一直对自己高要求，这不是为了跟别人比，这是一种习惯，对品质的追求就像是一种本能"
    ],
    "积极": [
        "对朋友的计划我总是做出积极的回应，因为我认为鼓励是很重要的",
        "我很少用恶意揣测他人，就算偶尔会吃亏",
        "遇到推销商品的，我有时也不想拒绝，因为我就是想让对方开心",
        "绝大部分时候我不容易焦虑，我认为没有什么事情太值得担心",
        "我有时是一个包容的人，这主要来自我的乐天，我觉得没必要计较太多，大家开开心心就好",
        "我有时会做出一些别人看来有风险的选择，不是因为我爱冒险，而是我更愿意看到好的一面",
        "比起做一个明智的人，我更愿意做一个乐观的人",
        "如果自己身上发生了一件好事，我会高兴好久",
        "我出现的地方，就会有愉快的气氛",
        "我不太会沉浸在悲伤中，甚至我感觉自己没有能力去体会太重的悲伤"
    ],
    "责任": [
        "答应别人的事情，我就会做到",
        "我很少迟到，迟到会让我过意不去，即便别人总是迟到",
        "我做了很多事情，一开始是别人需要我，然后是我不想让对方失望，从而全力把它们做好",
        "在任何公司，我在领导眼中都是比较靠谱的成员",
        "我认为自己算是一个道德感比较强的人",
        "我比别人更加鄙视投机和欠债",
        "虽然谋求一个职位是为了挣钱，但在具体的工作中，我勤恳工作仅仅因为我认为应该对我的工作伙伴负责",
        "我的工作分两种：一种是满足别人的期待，一种是做自己真正想做的事",
        "我认为我懂得什么是'使命感'",
        "我可能不是一个很自律的人，但只要在团队中工作，我就不会懒散"
    ],
    "排难": [
        "家里如果有东西坏了，我愿意马上去修，而不是拖着",
        "别人觉得很难的事情，我愿意去尝试，就是因为别人觉得它难",
        "我喜欢钻研一些事情，并不完全是因为好奇心，而是我期待达到某些实际的目的",
        "我的动手能力不错，我小时候能做到一些同龄人做不到的事情",
        "别人遇到困难向我求助，我有时会摩拳擦掌感到兴奋",
        "有的人会觉得太麻烦而不去解决一些问题，我忍不住帮他们解决",
        "有时别人觉得一切都好，但我会去发现问题，然后解决掉它",
        "上级给我一个很难的任务，我会充满斗志",
        "我会把自己看成一个客体去'修理'，比如如果我认为自己在性格或者技能上有哪些缺陷，我就去弥补",
        "我喜欢使用收纳整理工具，并非因为我有洁癖，而是我享受整理的过程，包括这些工具设计的巧思"
    ],
    "交往": [
        "跟什么样的人可以深交，对我来说不难判断，一句话，一个眼神，就能识别出彼此",
        "如果遇到对的人，我们很快会跟对方分享彼此的很多东西",
        "有的人即便很久没见面，再次相聚我们依然可以像老朋友一样交谈",
        "我认为我跟很多朋友的关系是坚实的",
        "在我信任的朋友面前，我可以表现得更像我自己，甚至我都能感到自己在发光。而在其他场合我很少这样",
        "跟别人交换自己的真实想法，对我来说并不困难，就算对方平时戴着面具，我也可以让他摘掉面具",
        "我没有塑料友谊，这种关系我会避开，我认为完全没有必要",
        "就算我比较社恐，也不影响我用一些方式引起我感兴趣的人的注意",
        "跟一群志同道合的朋友，去开创一个小事业，是我能想到的最幸福的事了",
        "我的伴侣一定是彼此精神十分默契的人"
    ],
    "自信": [
        "我对自己的判断充满信心，并非因为我生性乐观或者没有风险意识，而是我能够抓住事物的要点和规律",
        "我有时候显得很笃定，未必是真的很相信自己的判断，我认为有必要为大家指明一个方向，有方向比没有要好",
        "兵来将挡水来土掩，我认为没什么是不能应对的，就算我没有将和土，也不要紧",
        "我会向比我地位高的人提出要求甚至质疑，因为我认为我有能力让对方重视我的看法或建议",
        "不管别人怎么说，我对事情都有自己的独立判断",
        "我的生活经验越丰富，就越相信自己的判断",
        "我认为很多人太容易被一些无聊的说法影响了",
        "我会是一个很好的决策者",
        "我相信自己的经验远远超过书上的理论",
        "别人觉得很为难的事情，我觉得很简单，原因是我能够去抓要点。如果有的麻烦真的避免不掉，那就安心接受"
    ],
    "追求": [
        "我并不想平庸地度过一生",
        "我内心深处希望大家看到我、认可我、爱我。这也是我学习和工作的驱动力",
        "我从小就认为自己与众不同",
        "如果我成为名人或偶像，应该是很有特点的那种",
        "我羡慕那些成功的人，但我又不想去模仿他们",
        "如果能够找到自己的使命，那应该是去做一些颠覆性的事业",
        "如果我是一个建筑师，我希望自己的作品，是外星人来到地球上第一眼能够注意到的",
        "他人的否定和忽视，是我努力的动力",
        "如果做事情不做出些声响，为什么还要做？",
        "我不想成为第二"
    ],
    "战略": [
        "作为下属，领导给我布置一个含糊的任务，我也能处理好，因为我能留多个心眼，搜集信息综合判断",
        "我认为很多预测并不难做，有的时候只需要用排除法",
        "读历史或政治书籍的时候，我不会只当故事去看，我会认真思考每一种局势形成的原因，当事人的处境和选择",
        "我经常觉得别人做事的方式不够聪明",
        "我不一定有自己的明确目标，但如果别人告诉我他的目标，我就能告诉他达到目标的有效方法",
        "人们觉得我头脑清晰，我认为自己不过是用一些基本规律来进行思考和判断",
        "做抉择对我来说并不难，要么是一个选择明显优于另一个，如果二者差不多，选谁都行",
        "我感觉人们总把简单的事情搞复杂",
        "我认为自己可以成为智囊，不是因为我向往这一类工作，而是我了解自己擅长于此",
        "我理解东西比别人快，我认为最重要的原因是，我处理过很多的复杂信息，这种能力就像肌肉一样，越用越强"
    ],
    "取悦": [
        "到了一家新公司，最让我激动的是可以认识新的人",
        "我基本上可以称得上是社牛，跟陌生人交谈，我几乎没有障碍",
        "跟客户第一次见面，拉近关系赢得好感，对我来说是很简单的事",
        "我完全不担心跟人攀谈的时候冷场，就算对方真的不想跟我说话，我也不会觉得尴尬",
        "我有时问东问西，对方的话匣子就被打开了",
        "我经常抛出一些话头去试探别人，并不是我真的认为对方如此，我仅仅是想开启话题",
        "我认为跟不同的人建立关系是重要的，因为人是最重要的资源，也是我认识世界的途径",
        "我通过直接跟人交谈，去满足对人的好奇心，而不是通过看书什么的",
        "如果我想在别人面前证明或展示自己的实力，我就会变得很有表现力",
        "如果我在意的重要人物不喜欢我，我会想着该怎么征服对方"
    ]
};